<template>
  <v-app>
    <Header :isPublic="true" />
    <v-main>
      <div id="body">

      <v-container fluid class="body_content">
        <v-alert text type="info">
          <small class="text-info">
            Informação atualizada até {{ returnDateNow() }}
          </small>
        </v-alert>

        <h2>{{ titulo }}</h2>

        <div class="filtros-label">Filtros:</div>
        <v-row align="end">
          <v-col cols="12" md="3">
            <div class="campo-label">Ementa</div>
            <v-text-field
                outlined
                dense
                placeholder="Pesquisar por ementa..."
                v-model="filtro.ementa"
                v-on:keyup.enter="buscarDocumento()"
                hide-details
            />
          </v-col>
          <v-col cols="12" md="1">
            <div class="campo-label">Número</div>
            <v-text-field
                outlined
                dense
                type="number"
                placeholder="Nº"
                v-model="filtro.numero"
                v-on:keyup.enter="buscarDocumento()"
                hide-details
            />
          </v-col>
          <v-col cols="12" md="1">
            <div class="campo-label">Ano</div>
            <v-text-field
                outlined
                dense
                type="number"
                placeholder="Ano"
                v-model="filtro.ano"
                v-on:keyup.enter="buscarDocumento()"
                hide-details
            />
          </v-col>

          <v-col md="3" cols="12">
            <div class="campo-label">Tipo de Documento <span style="color:red">*</span></div>
            <v-select
                outlined
                dense
                :disabled="loadingSelect"
                :loading="loadingSelect"
                v-model="tipoDocumento"
                :items="tipos"
                item-text="nome"
                item-value="tipoDocumentoId"
                placeholder="Selecione..."
                return-object
                @change="atualizarFiltro"
                hide-details
            ></v-select>
          </v-col>

          <v-col cols="12" md="1">
            <v-btn
                color="primary"
                small
                depressed
                @click="buscarDocumento()"
            >
              <v-icon small>fa-search</v-icon>
            </v-btn>
          </v-col>
        </v-row>


        <v-row>
          <v-spacer></v-spacer>
          <v-btn
              :disabled="lista.length == 0"
              small
              color="primary"
              @click="baixarDados()"
          >
            <v-icon class="mr-2" small>fa-download</v-icon>
            Baixar Dados
          </v-btn>
        </v-row>

        <v-row justify="center">
          <v-col cols="12" md="12">
            <template>
              <v-data-table
                  :loading="loadingDocs"
                  @click:row="abrirHtml"
                  :headers="headers"
                  :items="lista"
                  :options.sync="options"
                  :server-items-length="totalElements"
                  :footer-props="{ itemsPerPageOptions: [10, 25, 50] }"
                  class="elevation-1 mytable"
                  no-results-text="A busca não trouxe resultados."
                  no-data-text="A busca não trouxe resultados."
              >
                <template v-slot:loading>
                  <LoadingSpinner text="Carregando documentos... aguarde." />
                </template>
                <template v-slot:item.dataInclusao="{ item }">
                  {{ formatarData(item.dataInclusao) }}
                </template>
              </v-data-table>
            </template>
          </v-col>
        </v-row>
      </v-container>


      </div>
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/template/Header.vue";
import LoadingSpinner from "@/components/template/LoadingSpinner.vue";
import documentoService from "@/service/DocumentoService";
import csvUtils from "@/service/CsvUtils";

export default {
  components: {
    Header,
    LoadingSpinner
  },
  data() {
    return {
      titulo: "Legislação",
      loadingDocs: false,
      filtro: {
        numero: null,
        ano: null,
        ementa: null,
        tipoDocumentoId: null,
        destino: null,
        status: null,
      },
      tiposDoc: [],
      tipos: [],
      tipoDocumento: {},
      lista: [],
      totalElements: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      listaStatus: ["Todos", "Vigente", "Revogado"],
      headers: [
        {text: "Número", value: "numero", sortable: false, width: "8%"},
        {text: "Ano", value: "ano", sortable: false, width: "8%"},
        {text: "Tipo", value: "tipoDocumento.nome", sortable: false, width: "15%"},
        //{ text: "Status", value: "status", sortable: false, align: "center" },
        {text: "Data de Publicação", value: "dataInclusao", sortable: false, width: "12%"},
        {text: "Ementa", value: "ementa", sortable: false},
      ],
      isExterno: false,
      isAtas: false,
      isDeliberacoes: false,
      loadingSelect: true,
    };
  },
  methods: {
    baixarDados() {
      // exporta todos os resultados do filtro atual, nao apenas a pagina exibida
      documentoService
        .buscarDocumentoFiltroPaginado(this.filtro, 0, this.totalElements)
        .then((result) => csvUtils.exportCsv(result.content));
    },

    returnDateNow() {
      return this.$moment().format("DD/MM/YYYY");
    },
    atualizarFiltro() {
      this.filtro.tipoDocumentoId = this.tipoDocumento.tipoDocumentoId;
    },
    buscarDocumento() {
      // nova pesquisa: volta para a primeira página
      if (this.options.page !== 1) {
        this.options.page = 1; // o watch de options dispara a busca
      } else {
        this.carregarPagina();
      }
    },
    carregarPagina() {
      if (this.loadingSelect) return;
      this.loadingDocs = true
      this.lista = []; //limpa antes: senão a tabela mostra os resultados antigos + a barra em vez do spinner
      if (this.filtro.status === "Todos") {
        this.filtro.status = null;
      }
      documentoService
        .buscarDocumentoFiltroPaginado(
          this.filtro,
          this.options.page - 1,
          this.options.itemsPerPage
        )
        .then((result) => {
          this.lista = result.content;
          this.totalElements = result.totalElements;
          this.atualizarHeaders();
          this.loadingDocs = false
        });
    },
    atualizarHeaders() {
      if (this.tipoDocumento.legislacao) {
        this.headers = [
          {text: "Número", value: "numero", sortable: false, width: "8%"},
          {text: "Ano", value: "ano", sortable: false, width: "8%"},
          {text: "Tipo", value: "tipoDocumento.nome", sortable: false, width: "15%"},
          {text: "Status", value: "status", sortable: false, align: "center"},
          {text: "Data de Publicação", value: "dataInclusao", sortable: false, width: "12%"},
          {text: "Ementa", value: "ementa", sortable: false},
        ];
      } else {
        this.headers = [
          {text: "Número", value: "numero", sortable: false, width: "8%"},
          {text: "Ano", value: "ano", sortable: false, width: "8%"},
          {text: "Tipo", value: "tipoDocumento.nome", sortable: false, width: "15%"},
          {text: "Data de Publicação", value: "dataInclusao", sortable: false, width: "12%"},
          {text: "Ementa", value: "ementa", sortable: false}]
      }
    },
    formatarData(data) {
      if (!data) {
        return "-";
      }
      const partes = data.split("-");
      return partes[2] + "/" + partes[1] + "/" + partes[0];
    },
    abrirHtml(doc) {
      if (doc.contemHtml) {
        let rota = this.$router.resolve(
            "/documentohtml/" + doc.documentoId + "?compilado=true"
        );
        window.open(rota.href, "_blank");
      } else {
        documentoService.downloadArquivo(doc.documentoId);
      }
    },

    retornaInterno(value) {
      if ([7, 5, 18, 2].includes(value.tipoDocumentoId)) {
        return true;
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.carregarPagina();
      },
      deep: true,
    },
  },
  async created() {
    // antes de qualquer await: a carga inicial da tabela (watch de options)
    // dispara logo após a montagem e precisa do destino já aplicado
    if (this.$route.query.destino && (this.$route.query.destino === "i" || this.$route.query.destino === "e")) {
      this.filtro.destino = this.$route.query.destino;
    }
    try {
      // destino "e" lista os tipos de legislacao do banco, ja na sequencia do campo "ordem";
      // os demais destinos usam a lista completa
      this.tiposDoc = this.$route.query.destino === "e"
        ? (await documentoService.findTiposLegislacao()) || []
        : (await documentoService.findTiposDocumento()) || [];

      if (this.$route.query.destino) {
        switch (this.$route.query.destino) {
          case "e": {
            this.titulo = "Pesquisa de Ato Normativo / Legislação";
            this.isExterno = true;
            this.tipos = this.tiposDoc;
            // Define "Instrução Normativa" como filtro padrão quando destino = "e"
            const instrucaoNormativa = this.tipos.find(value => value.tipoDocumentoId === 1);
            if (instrucaoNormativa) {
              this.tipoDocumento = instrucaoNormativa;
              this.filtro.tipoDocumentoId = instrucaoNormativa.tipoDocumentoId;
            }
            this._buscarAoCarregar = true;
            break;
          }
          case "i":
            this.titulo = "Boletim Interno";
            this.tiposDoc = this.tiposDoc.filter(this.retornaInterno);
            for (const j of [7, 5, 18, 2]) {
              const tipoi = this.tiposDoc.find(value => value.tipoDocumentoId === j);
              if (tipoi) {
                this.tipos.push(tipoi);
              }
            }
            break;
          case "deliberacoes-colegiadas":
            this.titulo = "Pesquisa de Jurisprudência";
            this.isDeliberacoes = true;
            for (const d of [14, 15, 16]) {
              const tiposDeliberacao = this.tiposDoc.find(value => value.tipoDocumentoId === d);
              if (tiposDeliberacao) {
                this.tipos.push(tiposDeliberacao);
              }
            }
            break;
          case "atas":
            this.titulo = "Pesquisa de Ata de Sessão Colegiada";
            this.isAtas = true;
            for (const a of [25, 26, 27]) {
              const tiposAta = this.tiposDoc.find(value => value.tipoDocumentoId === a);
              if (tiposAta) {
                this.tipos.push(tiposAta);
              }
            }
            break;
          default:
            this.tipos = [...this.tiposDoc];
        }
      } else {
        this.tipos = [...this.tiposDoc];
      }

      if (this.$route.query.tipo) {
        this.filtro.tipoDocumentoId = this.$route.query.tipo;
        const tipoDoc = await documentoService.buscarTipoDocumento(this.filtro.tipoDocumentoId);
        this.tipoDocumento = tipoDoc;
      }

      const docId = this.$route.query.doc ? parseInt(this.$route.query.doc, 10) : null;
      if (this.$route.query.destino === 'e' && docId && [23, 37, 38, 39, 40].includes(docId)) {
        this.filtro.tipoDocumentoId = docId;
        const tipoDoc = await documentoService.buscarTipoDocumento(this.filtro.tipoDocumentoId);
        this.tipoDocumento = tipoDoc;
      }
      
      this.loadingSelect = false;
      this.carregarPagina();
    } catch (error) {
      console.error('Erro ao carregar os tipos de documento:', error);
      this.loadingSelect = false;
    }
  },
};
</script>

<style scoped>

.body_content {
  margin: auto;
  padding: 2rem 5rem;
}

.text-info {
  color: #000000;
}

.filtros-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 4px;
  margin-top: 8px;
}

.campo-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #444;
  margin-bottom: 4px;
}
</style>